import { Trash2 } from 'lucide-react';

import { Feature } from '..';
import { lang } from '@lang';
import { setDeleteCustomerBlueprintModal, useAppDispatch } from '@state';

export const useDeleteCustomerBlueprintFeature = (designId: string, submissionId: string | null): Feature<boolean> => {
	const dispatch = useAppDispatch();

	const [enabled, tooltip] = (() => {
		return [true, lang.customer.tooltip.delete];
	})();

	return {
		name: 'deleteCustomerBlueprint',
		label: '',
		shortcut: '',
		tooltip,
		icon: () => <Trash2/>,
		disabled: !enabled,
		value: enabled,
		hidden: false,
		handler: () => {
			dispatch(setDeleteCustomerBlueprintModal({ isOpen: true, data: designId }));
		}
	};
};
